import "./modules/common";
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
import VueGoodshareXTwitter from "~/Components/SocialShare/XTwitter.vue";
import ConferenceBooker from "~/Components/Product/ConferenceBooker.vue";
import AccordionItem from "~/Components/AccordionItem.vue";
import SimpleMap from "~/Components/Common/SimpleMap.vue";
import SanitizeHtml from "~/Components/Common/SanitizeHtml.vue";
import WishlistModal from "~/Components/Wishlist/WishlistModal.vue";
import EventBookingModal from "~/Components/Events/EventBookingModal.vue";
import EventWaitingListModal from "~/Components/Events/EventWaitingListModal.vue";
import ErrorModal from "~/Components/Common/ErrorModal.vue";
import VueApp from "~/Scripts/new/vueApp";
import ConferenceDetails from "~/Components/Product/ConferenceDetails.vue";

new VueApp( {
  name: "ConferenceItem",
  components: {
    AccordionItem,
    ConferenceBooker,
    VueGoodshareEmail,
    VueGoodshareLinkedIn,
    VueGoodshareFacebook,
    VueGoodshareXTwitter,
    SimpleMap,
    SanitizeHtml,
    WishlistModal,
    EventBookingModal,
    EventWaitingListModal,
    ErrorModal,
    ConferenceDetails,
  },
  data () {
    return {
      showWishlistModal: false,
      showBookingModal: false,
      wishlistId: null,
      selectedInstance: null,
      showWaitingListModal: false,
      wantedQuantity: null,
      errorModal: {
        show: false,
        heading: undefined,
        title: undefined,
        message: undefined,
      },
    };
  },
  methods: {
    onWishlistSubmit ( args ) {
      this.wishlistId = args.data.id;
      this.showWishlistModal = false;
      this.showBookingModal = true;
    },
    onCloseBookingModal () {
      this.showBookingModal = false;
    },
    onCloseWaitingListModal () {
      this.selectedInstance = null;
      this.showWaitingListModal = false;
    },
    onBookingJoin ( instanceId, wantedQuantity ) {
      const match = this.instances.find( x => x.id === instanceId );
      this.wantedQuantity = wantedQuantity;

      if ( match ) {
        this.selectedInstance = match;
        this.showWaitingListModal = true;
      }
    },
    handleWaitingListError ( apiErrorCode ) {
      this.errorModal.show = true;
      this.errorModal.heading = "Event Booking";

      switch ( apiErrorCode ) {
        case 108:
        case "108":
          this.errorModal.title = "Attendance capacity reached";
          this.errorModal.message = `<p>You have reached the maximum number of delegates permitted from one organisation</p>
                                     <p>
                                     <span class="event-booking-modal__asterisk">*</span>
                                     <i>This will include delegates from other bookings</i>
                                     </p>`;
          break;
        case 120:
        case "120":
          this.errorModal.title = "No spaces available";
          this.errorModal.message = "<p>There are not enough spaces availble to complete your booking.</p>";
          break;
        case 117:
        case "117":
          this.errorModal.title = "Waiting list is full";
          this.errorModal.message = "<p>We are sorry, due to popularity the waiting list for this event is full.</p>";
          break;
        default:
          break;
      }
    },
  },
} );
